// extracted by mini-css-extract-plugin
export default {"main_content":"index_main_content_WJmj4","end":"index_end_1O-ki"};